import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getZorTerritorySettings } from '@/actions/zor-territory-settings/getZorTerritorySettings';
import { ApiResponse } from '@/types/response.type';
import { ZorTerritorySettings } from '@/types/zor.territory-settings.type';

export interface UseGetZorTerritorySettingsReturn {
  result: ApiResponse<ZorTerritorySettings> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

export const useGetZorTerritorySettings =
  (): UseGetZorTerritorySettingsReturn => {
    const query: UseQueryResult<
      ApiResponse<ZorTerritorySettings> | undefined,
      Error
    > = useQuery({
      queryKey: ['zor-territory-settings'],
      queryFn: getZorTerritorySettings,
    });

    return {
      result: query.data,
      error: query.error,
      isError: query.isError,
      isSuccess: query.isSuccess,
      isLoading: query.isPending,
    };
  };
